import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Header } from './components/header/header';
import { Sidebar } from './components/sidebar/sidebar';
import { CommonModule } from '@angular/common';
import { WebsocketService } from './services/websocket/websocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss', './layout.scss'],
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    Header,
    Sidebar,
    CommonModule,
  ],
})
export class App implements OnInit {
  title = 'frontend';
  shouldRenderLayout = false;
  isHomePage = false; // nova variável

  constructor(
    private readonly router: Router,
    private titleService: Title,
    private websocketService: WebsocketService
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Saúde Conectada');

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        if (!url.includes('/auth') && !sessionStorage.getItem('token')) {
          this.router.navigateByUrl('/auth/login');
        }

        this.shouldRenderLayout = !url.includes('/auth');
        this.isHomePage = url === '/home';

        if (!url.includes('/auth') && sessionStorage.getItem('token')) {
          this.initializeWebSocket();
        } else if (url.includes('/auth')) {
          this.websocketService.disconnect();
        }
      });
  }

  private initializeWebSocket(): void {
    // console.log('App: Inicializando WebSocket...');
    if (!this.websocketService.isConnected()) {
      this.websocketService.connect();
    }
  }
}
